import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/cybernet";

export const Services = () => {
  const scrollToCatalog = (id) => {
    const el = document.getElementById("catalogo");
    if (el) el.scrollIntoView({ behavior: "smooth" });
    // Set hash so catalog can focus tab
    window.location.hash = `catalog-${id}`;
    window.dispatchEvent(new CustomEvent("cn:catalog:focus", { detail: id }));
  };

  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="bg-[#FAFAFA] py-20 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
          <div>
            <div className="uppercase text-xs font-bold tracking-[0.25em] text-[#E10600] mb-4">
              — Qué hacemos
            </div>
            <h2 className="font-display font-black text-4xl sm:text-5xl tracking-tighter text-[#0A0A0A] max-w-2xl">
              Cuatro áreas, una sola misión: resolverte.
            </h2>
          </div>
          <p className="text-[#52525B] max-w-md text-base leading-relaxed">
            Desde un trámite en línea hasta la instalación de cámaras de
            seguridad — te acompañamos en cada paso.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {SERVICES.map((s) => (
            <article
              key={s.id}
              data-testid={`service-card-${s.id}`}
              className="group relative bg-white border border-[#E4E4E7] p-8 md:p-10 hover:border-[#E10600] hover:-translate-y-1 transition-all duration-300 rounded-sm overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#E10600] opacity-0 group-hover:opacity-5 transition-opacity" />
              <div className="flex items-start justify-between gap-6">
                <div className="flex-1">
                  <div className="font-display font-black text-xl text-[#E10600] mb-2">
                    {s.number}
                  </div>
                  <h3 className="font-display font-bold text-2xl md:text-3xl leading-tight text-[#0A0A0A] mb-4">
                    {s.title}
                  </h3>
                  <p className="text-[#52525B] leading-relaxed mb-6">
                    {s.short}
                  </p>
                  <button
                    data-testid={`service-more-${s.id}`}
                    onClick={() => scrollToCatalog(s.id)}
                    className="inline-flex items-center gap-2 text-sm font-semibold text-[#0A0A0A] border-b-2 border-[#0A0A0A] pb-1 hover:text-[#E10600] hover:border-[#E10600] transition-colors"
                  >
                    Ver más
                    <ArrowUpRight className="h-4 w-4" />
                  </button>
                </div>
                <div className="hidden sm:block w-28 h-32 shrink-0 overflow-hidden rounded-sm">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    loading="lazy"
                  />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
